import { render, staticRenderFns } from "./PreviousButton.vue?vue&type=template&id=f641a078&"
import script from "./PreviousButton.vue?vue&type=script&lang=js&"
export * from "./PreviousButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f641a078')) {
      api.createRecord('f641a078', component.options)
    } else {
      api.reload('f641a078', component.options)
    }
    module.hot.accept("./PreviousButton.vue?vue&type=template&id=f641a078&", function () {
      api.rerender('f641a078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/PreviousButton/PreviousButton.vue"
export default component.exports